import { Helmet } from "react-helmet";

const Seo = ({ data }) => {
  const baseUrl = "https://springeveningpl.com/";
  const url = `${baseUrl}${data.pathSlug}`;

  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      {/* Basic SEO */}
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
    </Helmet>
  );
};

export default Seo;
